module.exports = function() {
  return new Worker("/" + "fa111a1a50d4ef8a82a2.worker.js");
};